import { BaseStateI } from '@interfaces/redux/base-state';
import { RecordsPaginationI } from '@interfaces/scheduller/record-itemI';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { readPatientRecords } from '@services/patient';

export interface PatientRecordsState extends BaseStateI {
    patientRecords: RecordsPaginationI | null;
}
const fetchPatientRecords = createAsyncThunk(
    'patient/fetchPatientRecords',
    async (
        recordsQuery: {
            patientUsername: string;
            pageSize: number;
            lastDocumentId?: string;
        },
        thunkAPI
    ) => {
        const data = await readPatientRecords(recordsQuery);
        return data;
    }
);

const patientRecordsSlice = createSlice({
    name: 'patient-records',
    initialState: {
        error: null,
        patientRecords: null,
        status: 'idle',
    } as PatientRecordsState,
    reducers: {
        resetPatient: (state) => {
            state.error = null;
            state.patientRecords = null;
            state.status = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPatientRecords.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchPatientRecords.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
        builder.addCase(fetchPatientRecords.fulfilled, (state, action) => {
            state.status = 'succeeded';
            if (!state.patientRecords) {
                state.patientRecords = action.payload;
            } else {
                state.patientRecords.appointmentRecordList = [
                    ...state.patientRecords.appointmentRecordList,
                    ...action.payload.appointmentRecordList,
                ];
                state.patientRecords.totalRows = action.payload.totalRows;
            }
        });
    },
});

export const { resetPatient } = patientRecordsSlice.actions;
export default patientRecordsSlice.reducer;
